/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PrintExampleConfigurationDto } from '../models/PrintExampleConfigurationDto';
import type { PrintExampleDto } from '../models/PrintExampleDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PrintExampleService {

    /**
     * @returns PrintExampleDto Successfully uploaded a print example
     * @throws ApiError
     */
    public static postUploadPrintExample({
        formData,
    }: {
        formData?: {
            file: Blob;
        },
    }): CancelablePromise<PrintExampleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/print-examples',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation errors`,
            },
        });
    }

    /**
     * @returns PrintExampleDto Requested configuration found.
     * @throws ApiError
     */
    public static getShowPrintExampleForConfiguration({
        configurationId,
    }: {
        configurationId: string,
    }): CancelablePromise<PrintExampleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurations/{configurationId}/print-example',
            path: {
                'configurationId': configurationId,
            },
            errors: {
                404: `Requested configuration not found.`,
            },
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static deleteRemovePrintExampleFromConfiguration({
        configurationId,
    }: {
        configurationId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/configurations/{configurationId}/print-example',
            path: {
                'configurationId': configurationId,
            },
            errors: {
                404: `Requested configuration not found.`,
            },
        });
    }

    /**
     * @returns any Successfully saved print example to configuration.
     * @throws ApiError
     */
    public static putSavePrintExampleForConfiguration({
        uuid,
        requestBody,
    }: {
        /**
         * An existing configuration UUID.
         */
        uuid: string,
        /**
         * Request body
         */
        requestBody: PrintExampleConfigurationDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurations/{uuid}/print-example',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Saving print example to configuration failed.`,
            },
        });
    }

}
